import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import Subtitle from '../ui/Subtitle';
import Selector from '../ui/Selector';
import { backendFetch } from '../../backend/backend';
import BaseLeagueTable from '../tables/BaseLeagueTable';
import ScoringStructureSection from '../tables/ScoringStructureSection';
import ResultsByPlayerTable from '../tables/ResultsByPlayerTable';

const HistoryPage = () => {
    const [seasons,setSeasons]=useState([]);
    const [season,setSeason]=useState();
    const [leagueTable,setLeagueTable]=useState();
    const [scoringStructure,setScoringStructure]=useState();
    const [resultsTable,setResultsTable]=useState([]);
    const [playersList,setPlayersList]=useState([]);

    useEffect(()=>{
        const fetchData=async ()=>{
            const seasons=(await backendFetch('/seasons')).filter((s)=>s.status==='past').map((s)=>s.startDate);
            setSeasons(seasons);
            setSeason(seasons[0]);
        }
        fetchData();
    },[])

    useEffect(()=>{
        const fetchLeagueData=async ()=>{
            if (season)
            {
                const league=await backendFetch(`league?season=${season}`);
                setLeagueTable(league);
                const scoring=await backendFetch(`scoring?season=${season}`);
                setScoringStructure(scoring);
                const players=await backendFetch(`players?season=${season}`);
                setPlayersList(players);
                const results=await backendFetch(`results?season=${season}`);
                setResultsTable(results);
            }
        }
        fetchLeagueData();
    },[season])

    return(
        <Stack>
            <Subtitle text="History"/>
            {season &&
            <Selector
                value={season}
                values={seasons}
                onChange={(v)=>setSeason(v)}
            />
            }
            { leagueTable && <BaseLeagueTable leagueTable={leagueTable} /> }
            { scoringStructure && <ScoringStructureSection scoringStructure={scoringStructure} /> }		
            { resultsTable && <ResultsByPlayerTable playersList={playersList} resultsTable={resultsTable} /> }
        </Stack>
    );
}

export default HistoryPage;
